import { BikeSpec } from './types';

/** KTM 350 EXC-F (2024). KTM spec sheet: 349.7 cc 4T, 6 speed wide ratio, 105.8 kg without fuel. */
export const KTM350EXCF: BikeSpec = {
  id: 'ktm350excf', brand: 'KTM', name: '350 EXC-F', year: 2024, kind: 'enduro', stroke: '4T', displacement: 350,
  dryMass: 105.8, peakPower: 34, peakPowerRpm: 11000, peakTorque: 32, peakTorqueRpm: 8500, limiterRpm: 13000, idleRpm: 1800,
  torqueCurve: [[1800, 0.5], [4000, 0.72], [6500, 0.92], [8500, 1], [11000, 0.92], [13000, 0.72]],
  primary: 76 / 24, gearbox: [33 / 12, 31 / 15, 28 / 17, 26 / 20, 25 / 23, 22 / 24], finalDrive: 52 / 14,
  travelFront: 300, travelRear: 310, seatHeight: 960, wheelbase: 1487,
  level: 'advanced', discipline: 'track', livery: 'factory',
  // The KTM 450 EXC model: same frame, bodywork and year range, a different engine.
  model: { base: 'KTM 450 EXC', approximate: true },
  schoolMap: 0.78,
  audio: { set: '4t', pitch: 0.96 },
  estimated: ['peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve', 'gearbox'],
};
